import { RecordOrigin } from '@sr/types';
import { getPartnerRecordOrigin } from '@sr/utils';

/**
 * Whether a Partner record carries the Datalake field shape — keyed by dwKey, with
 * delivery addresses as children. True for Datalake and Confidential records alike.
 */
export const usesDatalakeFieldShape = (source?: string) =>
  getPartnerRecordOrigin({ source: source ?? '' }) !== RecordOrigin.EDW;

/** Whether a Partner record came from the Datalake specifically, rather than Confidential. */
export const isDatalakeRecord = (source?: string) =>
  getPartnerRecordOrigin({ source: source ?? '' }) === RecordOrigin.DL;
